import { IBranchCreate, IBranchFilters, IBranchUpdate } from "../../types/branch";
import { ITableProps } from "../../types/table";
import { api } from "../api"

const BranchesService = async (table: ITableProps, filters: IBranchFilters) => {

    const response = await api.get('branches', {
        params: {
            pageNumber: table.page,
            pageSize: table.pageSize,
            direction: table.direction,
            sortBy: table.sortBy,
            ...filters
        }
    });

    return response;

}

const AllBranchesService = async () => {

    const response = await api.get('branches/all');

    return response;

}

const CreateBranchService = async (data: IBranchCreate) => {

    const response = await api.post('branches', data);

    return response;

}

const UpdateBranchService = async (data: IBranchUpdate) => {

    const response = await api.put(`branches/${data.id}`, data);

    return response;

}

const DeleteBranchService = async (id: number) => {

    const response = await api.delete(`branches/${id}`);

    return response;

}

const ActiveBranchService = async (id: number) => {

    const response = await api.delete(`branches/active/${id}`);

    return response;

}

export {
    BranchesService,
    AllBranchesService,
    CreateBranchService,
    UpdateBranchService,
    DeleteBranchService,
    ActiveBranchService
}